module.exports = __webpack_public_path__ + "img/teen-patti_one-day.f97b8e8.jpg";